export enum PricingSurchargeConditionType {
  None = 'none',
  Length = 'length',
  Width = 'width',
  Size = 'size',
  Style = 'style',
  Siding = 'siding',
  Roof = 'roofing',
  Gauge = 'gauge',
  Region = 'region',
  State = 'state',
  Subtotal = 'subtotal',
  Leg = 'leg',
}
